export const images = [
  { id: 1, original: "/images/services/1/sub-categories/2/c1-s2-p1.jpg" },
];
